"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderMapObject = void 0;
var React = require("react");
var NearbymapState_1 = require("@/pages/common/states/NearbymapState");
var myokay_map2_1 = require("@okay/myokay-map2");
var renderMapObject = function (object, i, onMapObjectClick, onMapObjectsClick, onMarkerClick) {
    var onObjectClick = function () { return onMapObjectClick(object, i); };
    var onObjectsClick = function (objects) { return onMapObjectsClick(objects); };
    switch (object.kind) {
        case NearbymapState_1.NearbymapObjectKind.MARKER: {
            var onMarkerClicked = function () { return onMarkerClick(object, i); };
            return (React.createElement(myokay_map2_1.GoogleMapMarker, { key: i, zIndex: i, active: object.active, center: object.center, type: object.icon, onClick: onMarkerClicked }));
        }
        case NearbymapState_1.NearbymapObjectKind.WINDOW: {
            var infoWindowStyle = object.active ? 'o-googlemap__infowindow--active' : '';
            return (React.createElement(myokay_map2_1.GoogleMapInfoWindow, { active: object.active, key: i, center: object.center },
                React.createElement("div", { className: infoWindowStyle, onClick: onObjectClick }, object.title)));
        }
        case NearbymapState_1.NearbymapObjectKind.PRICETAG: {
            return (React.createElement(myokay_map2_1.GoogleMapTextLabel, { active: object.active, key: i, zIndex: i, center: object.center, value: object.value, onClick: onObjectsClick }));
        }
        case NearbymapState_1.NearbymapObjectKind.PIN: {
            return (React.createElement(myokay_map2_1.GoogleMapPin, { key: i, zIndex: i, center: object.center, title: object.title, onClick: onObjectClick }));
        }
        case NearbymapState_1.NearbymapObjectKind.ROUTE: {
            return React.createElement(myokay_map2_1.GoogleMapRoute, { key: i, route: object.path });
        }
    }
};
exports.renderMapObject = renderMapObject;
